import type { TeacherPageView } from "~/business-areas/teacher/teacher.model";

export async function useTeacherPageData(slug: string) {
  const { t } = useI18n();
  const cachedData = useTeacherCache().getBySlug(slug);

  const { data: teacher } = await useFetch(`/api/teachers/${slug}`, {
    deep: false,
    /*
     Lazy behaviour only if course has been previously cached from course any card list
     If not, course page view request is executed before route navigation and we can ensure
     that we don't throw 404 error in case of empty cache but existing course
    */
    lazy: !!cachedData,
    default: () => cachedData,
    transform(data): TeacherPageView | null {
      if (!data) return null;

      return {
        ...data,
        _links: {
          teacherPage: {
            name: "trainers-slug",
            params: {
              slug: data.slug!,
            },
          },
        },
        mainTag: data.tags[0],
        courses: data.courses.map((course) => {
          const ratings = course.ratings[0];

          return {
            ...course,
            ratings:
              ratings.avg !== null && ratings.count > 0
                ? {
                    avg: ratings.avg,
                    count: ratings.count,
                  }
                : null,
          };
        }),
      };
    },
  });

  if (!teacher.value) {
    throw createError({
      statusCode: 404,
      statusMessage: t("app.errors.page_not_found"),
      fatal: true,
    });
  }

  return {
    teacher: teacher as Ref<TeacherPageView>,
  };
}
